import { gql } from "@apollo/client";

export const CREATE_PARAMETER = gql`
    mutation createParameter($data: CreateParameterInput!) {
        createParameter(data: $data) {
            id
            name
            key
            value
            is_deleted
        }
    }
`;

export const UPDATE_PARAMETER = gql`
    mutation updateParameter($data: UpdateParameterInput!) {
        updateParameter(data: $data) {
            id
            name
            key
            value
            is_deleted
        }
    }
`;

export default CREATE_PARAMETER;
